import { render, staticRenderFns } from "./WorkDividedInContentWrapperColumn.vue?vue&type=template&id=3ff7fe85"
import script from "./WorkDividedInContentWrapperColumn.vue?vue&type=script&lang=js"
export * from "./WorkDividedInContentWrapperColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports